import incidentManagementApi from '@innovyze/stylovyze/lib/apis/incident.management.api';
export const getIncidents = (params) => {
    return incidentManagementApi.get('/incidents', {
        params: params,
    });
};
export const createActivity = (body) => {
    return incidentManagementApi.post('/activity', body);
};
